var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioButtonDisabledChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.83317C7.7 5.83317 5.83333 7.69984 5.83333 9.99984C5.83333 12.2998 7.7 14.1665 10 14.1665C12.3 14.1665 14.1667 12.2998 14.1667 9.99984C14.1667 7.69984 12.3 5.83317 10 5.83317ZM10 1.6665C5.4 1.6665 1.66666 5.39984 1.66666 9.99984C1.66666 14.5998 5.4 18.3332 10 18.3332C14.6 18.3332 18.3333 14.5998 18.3333 9.99984C18.3333 5.39984 14.6 1.6665 10 1.6665ZM10 16.6665C6.31666 16.6665 3.33333 13.6832 3.33333 9.99984C3.33333 6.3165 6.31666 3.33317 10 3.33317C13.6833 3.33317 16.6667 6.3165 16.6667 9.99984C16.6667 13.6832 13.6833 16.6665 10 16.6665Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonDisabledChecked);
export default __webpack_public_path__ + "static/media/radio_button_disabled_checked.f2178e271d8e5f68beac591d31cd3fd3.svg";
export { ForwardRef as ReactComponent };